module.exports = __webpack_public_path__ + "static/media/box-right-analytics.14b0faec.png";